

export const inSectence = (word, sentence = '') => {
    
    var reg = new RegExp(word.toLowerCase());
    let substr = word.slice(0,3).toLowerCase();
    var subReg = new RegExp(substr);
    let res = sentence.split(" ").filter((term) => {
        let wordStr = term.toLowerCase();
        return ( wordStr.match(reg) || wordStr.match(subReg)  ) ? true : false ;
    });

    return res.length === 0 ? false : true;
    
}

const inGreeting = (word, sentence = '') => {
    sentence = sentence.toLocaleLowerCase();
   return sentence.indexOf(word) > -1 && sentence.indexOf(word) === 0;
}

export const isGreeting = (sentence) => {
    return inGreeting("hello", sentence) || inGreeting("hi", sentence)
}

export const elipsize = (text) => {
    return text.slice(0,100)+"...";
}

export const shortEllipsis = (text) => {
    return text.slice(0,50)+"...";
}


export const capitalizeLink = (url) => {
    let linkTxt = url.split("/")[1];
    let firstLetter = linkTxt.slice(0,1).toUpperCase();
    let rest = linkTxt.slice(1, linkTxt.length);
    return firstLetter+rest;
}